module.exports = __webpack_public_path__ + "img/33600.ed619a36.jpg";